/**
 * Wallpaper Carousel
 */
import Flickity from 'flickity';

const skinsCarousel = document.querySelector('.js-skins-carousel');
const skinsCarouselTriggers = [...document.querySelectorAll('.js-skins-carousel-trigger')]
    .map(node => ({
        node,
        index: Number(node.getAttribute('data-slide')) - 1,
    }));


const flkty = new Flickity(skinsCarousel, {
    lazyLoad: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    draggable: false,
});


function setCurrentSlide(index) {
    flkty.select(index);
}


skinsCarouselTriggers.forEach((trigger) => {
    trigger.node.addEventListener('click', () => {
        setCurrentSlide(trigger.index);
    });
});


flkty.on('select', () => {
    skinsCarouselTriggers.forEach((trigger) => {
        if (trigger.index === flkty.selectedIndex) {
            trigger.node.classList.add('is-active');
        } else {
            trigger.node.classList.remove('is-active');
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/features/wallpaperCarousel.js